class quantityChanger extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.FetchedContent.bind(this));
  }
  FetchedContent() {
   var qty = parseInt(this.closest('.qty-box').querySelector('[name="quantity"]').value);
    console.log("Before Quantity: "+qty);
    if(this.classList.contains('qty-plus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
    // console.log("Quantity: "+qty);
    this.closest('.qty-box').querySelector('[name="quantity"]').value = qty;
  }
}
if (!customElements.get('quantity-changer')) {
  customElements.define('quantity-changer', quantityChanger);
}

class sticyButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.FetchedContent.bind(this));
  }
  FetchedContent() {
    if (this.hasAttribute('disabled')) return;
   var qty = parseInt(this.closest('.right').querySelector('[name="quantity"]').value);
    console.log('.qty'+qty);
    if(document.querySelector('input.QuantitySelector__CurrentQuantity')) {      
      document.querySelector('input.QuantitySelector__CurrentQuantity').value = qty;
    }
   document.querySelector('.ProductForm__AddToCart').click();
    
  }
}
if (!customElements.get('sticy-button')) {
  customElements.define('sticy-button', sticyButton);
}
class ProductSwach extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.FetchedContent.bind(this));
  }
  FetchedContent() {
    document.querySelector('body').classList.add('is---loading');
    fetch(this.getAttribute('href'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

         var product_title = responseHTML.querySelector('head title').innerHTML;
        console.log("title: "+product_title);
     // this.productElement = responseHTML.querySelector('#product_page_main__section');
     this.productElement = responseHTML.querySelector('#MainContent');
        this.closest("#MainContent").querySelector('.sticky_product_bar').innerHTML = responseHTML.querySelector('.sticky_product_bar').innerHTML;
        // this.setInnerHTML(this.closest('#product_page_main__section'), this.productElement.innerHTML);
        this.setInnerHTML(this.closest('#MainContent'), this.productElement.innerHTML);
        if(document.querySelector('body').classList.contains('is---loading')){
          document.querySelector('body').classList.remove('is---loading');
        }
        this.updateCurrentUrl(this.getAttribute('href'),product_title);
      
      var main_url = window.location.href;
  setTimeout(function(){
var product_link = window.location.href;  
var product_link_1=product_link.split("discount=");
if(product_link_1[1] == undefined){
  var get_item = localStorage.getItem("discount_code");
  var code=get_item;
}
  else{
    var discount_split = product_link_1[1].split("&");
  var discount_created = discount_split[0];
    var code = discount_created;
    localStorage.setItem("discount_code",code);
    var discount_created = "NEW50"
    var symbol = "="
    var final = symbol+code;
    localStorage.setItem("discount",final);
  }  
    
$.ajax({
  type: "POST",
  url: '/apps/discount/index.php?code='+code,
  data: 'data',
  dataType: 'json', 
  success: function(data){
    var main_url = window.location.href;
    var pathname = window.location.pathname;
if(main_url.indexOf('products') != -1){
    var discount_valid = true;
  var get_pro_id = parseInt(document.querySelector(".arv-collection").getAttribute("product-id"));
  //alert(get_pro_id);
    var entitled_product_ids = data['entitled_product_ids'];
    if(entitled_product_ids.length >0){
            if(entitled_product_ids.indexOf(get_pro_id) !== -1){  
               var discount_valid = true; 
              }   
            else {  
                var discount_valid = false;
                 }   
                 }
    else {
      var discount_valid = true;
    }
  //alert(discount_valid);
    if(discount_valid == true){
    var value=data['value']; console.log('value = '+value);
    var value_type=data['value_type']; console.log('value_type = '+value_type);
    var value_spl=value.split("-"); console.log('value_spl = '+value_spl);
    var discount=value_spl[1]; console.log('discount = '+discount);
    var disc_1=$(".pro_detail_swatches[data-id='"+get_pro_id+"']").attr("data-price");
      console.log('disc_1 = '+disc_1);
    var currency=$(".pro_detail_swatches[data-id='"+get_pro_id+"']").attr("data-currency");
    var id=$(".pro_detail_swatches[data-id='"+get_pro_id+"']").attr("data-id");
    var var_price=$(".pro_detail_swatches[data-id='"+get_pro_id+"']").attr("var-price");
    var disc_2=parseFloat(disc_1)/100; 
      console.log('disc_2 = '+disc_2);
    if(value_type == 'percentage'){
    var value_type_sign = '%';
    var disc_3=((disc_2*discount)/100);
   var disc_3 = disc_3.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

    var disc_4=disc_2-disc_3;
    disc_4 = disc_4.toFixed(2);
    }
      
    else if(value_type == "fixed_amount"){
    var value_type_sign = '';
    var disc_4=parseFloat(disc_2)-parseFloat(discount);
      console.log('val fixed = '+disc_4);
      }
    $(".discount-data").attr("data-value",discount);
    $(".discount-data").attr("data-type",value_type);
    var final_discount = parseFloat(disc_4).toFixed(2);
      
      
     if(final_discount.split(".")[1] == 99){
  final_discount = Math.round(final_discount); 
       final_discount = final_discount.toFixed(2);  
       final_discount = final_discount.replace('.',',');
     
       
}  else{
           final_discount = final_discount.replace('.',',');
       console.log('final_discount = '+final_discount);
}
      $(".Product__Info .spc_text").remove();
      var spc_html='<div class="spc_prc"><span class="comp_prc">'+var_price+'</span><span class="PDP reg_prc">'+currency+final_discount+'</span></div>';
    var desc_sec='<div class="spc_text">'+value+''+value_type_sign+' mit dem Code '+code+'</div>';
    $(".ProductMeta span.sale_at_price").html(spc_html);
      // $(".ProductMeta span.sale_at_price").html("");
    $(".ProductMeta .review_div.desk_top_sec").after(desc_sec);
    // $("h5.mob_product_title").after(spc_html); 
      $(".ProductMeta__PriceList.mob_pr_div .sale_at_price").html(spc_html);
    // $('.ProductMeta__PriceList.mob_pr_div').addClass('discount_active');
   $(".breadcrumb_div_product .spc_text").remove();
   $(".breadcrumb_div_product").append(desc_sec);
         $(".discount_media_bar .code_value").html(code);
  $(".discount_media_bar").show();
  setTimeout(function(){
      $(".price-sticky-div").html($(".final-price-divs").html());
      },2500);
      
    }
    else{
      $(".discount_media_bar").hide();
    }
}
// else if(main_url.indexOf('collections') != -1) {
//     var entitled_product_ids = data['entitled_product_ids'];
// // FOR COLLECTION PAGE
//   var discount_valid = false;
//   $('.ProductList .pro_detail').each(function(){
//    var disc_1=$(this).attr("data-price");
//    var currency=$(this).attr("data-currency");
//    var id = $(this).attr("data-id");
//     var get_pro_id = id;
//    var var_price=$(this).attr("var-price"); 
//    var disc_2=parseFloat(disc_1)/100;
//     if(entitled_product_ids.length >0){
//       var discount_valid = false;
//       var i;
//       for(i=0;i<=entitled_product_ids.length-1;i++){
//       if(entitled_product_ids[i] == id){
//       var discount_valid = true; 
//     var coupen = localStorage.getItem("discount_code");
//     var base_url = window.location.origin;  
//     var discount_url = base_url+"/discount/"+coupen;
//     $.get(discount_url,function(){
//     });  
//       }   
//       else {  
//       var discount_valid = false;
//       }
//     if(discount_valid == true) {
//     var value=data['value'];
//     var value_type=data['value_type'];
//     var value_spl=value.split("-");
//     var discount=value_spl[1];
//     if(value_type == 'percentage'){
//     var value_type_sign = '%';
//     var disc_3=((disc_2*discount)/100);
//     var disc_3 = disc_3.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

//     var disc_4=disc_2-disc_3;
//     }
//     else if(value_type == "fixed_amount"){
//     var value_type_sign = '';
//     var disc_4=parseFloat(disc_2)-parseFloat(discount);
//       }
//     $(".discount-data").attr("data-value",discount);
//     $(".discount-data").attr("data-type",value_type);
//    var final_discount = disc_4.toFixed(2);
//       if(final_discount.split(".")[1] == 99){
//   final_discount = Math.round(final_discount);   
//         final_discount = final_discount.toFixed(2);   
//         final_discount = final_discount.replace('.',',');
// }  else{
//            final_discount = final_discount.replace('.',',');
// }
//       // $(this).find('.price_div').prepend('<span class="disc_applied">Mit Code '+ coupen+' nur noch</span>')
//       if(coupen != ''){
//     $(".show_discount_message_3647").text("Dein Code "+coupen+" ist jetzt aktiv. Viel Spaß beim shoppen.");  
// }else{
//      $(".show_discount_message_3647").hide();
// } 
//     $('<div class="spc_prc"><span class="disc_applied">Mit Code '+ coupen+' nur noch</span><span class="reg_prc">'+currency+final_discount+'</span></div>').insertAfter($(this).find('span.main_price')); 
//    $(this).find('span.main_price').addClass('compr_prc '+coupen);
      
//     }
//       }
//       }
//     else {
//       var discount_valid = true;
//       if(discount_valid == true) {
//    var disc_2=parseFloat(disc_1)/100;
//    var value=data['value'];
//     var value_type=data['value_type'];
//     var value_spl=value.split("-");
//     var discount=value_spl[1];
//     if(value_type == 'percentage'){
//     var value_type_sign = '%';
//     var disc_3=((disc_2*discount)/100).toFixed(2);
//     var disc_4=parseFloat(disc_2)-parseFloat(disc_3);
//     }
//     else if(value_type == "fixed_amount"){
//     var value_type_sign = '';
//     var disc_4=parseFloat(disc_2)-parseFloat(discount);
//       }
//     $(".discount-data").attr("data-value",discount);
//     $(".discount-data").attr("data-type",value_type);
//    var final_discount = disc_4.toFixed(2);
//         if(final_discount.split(".")[1] == 99){
//   final_discount = Math.round(final_discount);   
//           final_discount = final_discount.toFixed(2); 
//           final_discount = final_discount.replace('.',',');
// }  else{
//            final_discount = final_discount.replace('.',',');
// }
//     $('<div class="spc_prc"><span class="reg_prc">'+currency+final_discount+'</span></div>').insertAfter($(this).find('span.main_price')); 
//    $(this).find('span.main_price').addClass('compr_prc');  
//         var coupen = localStorage.getItem("discount_code");
//     var base_url = window.location.origin;  
//     var discount_url = base_url+"/discount/"+coupen;
//     $.get(discount_url,function(){
//     });
//       }
//     }
//   });
// }
//     else if(pathname == '/'){
//      // FOR HOMEPAGE 
//       var discount_valid = false;
//     var entitled_product_ids = data['entitled_product_ids'];  
//       $(".home_page_products .home_page_products_inner_flx .pro_detail").each(function(){
//       var disc_1=$(this).attr("data-price");
//       var currency=$(this).attr("data-currency");
//       var id = $(this).attr("data-id");
//       var get_pro_id = id;
//       var var_price=$(this).attr("var-price"); 
//       var disc_2=parseFloat(disc_1)/100;
//        if(entitled_product_ids.length >0) {
//       var discount_valid = false;
//       var i;
//       for(i=0;i<=entitled_product_ids.length-1;i++){
//       if(entitled_product_ids[i] == id){
//       var discount_valid = true; 
//     var coupen = localStorage.getItem("discount_code");
//     var base_url = window.location.origin;  
//     var discount_url = base_url+"/discount/"+coupen;
//     $.get(discount_url,function(){
//     });  
//       }   
//       else {  
//       var discount_valid = false;
//       }
//     if(discount_valid == true) {
//     var value=data['value'];
//       //alert("jj");
//     var value_type=data['value_type'];
//     var value_spl=value.split("-");
//     var discount=value_spl[1];
//     if(value_type == 'percentage'){
//     var value_type_sign = '%';
//     var disc_3=((disc_2*discount)/100);
//    var disc_3 = disc_3.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
//     var disc_4=disc_2-disc_3;
//     //disc_4 = disc_4.toFixed(2);
//       //alert(disc_4);
//     }
//     else if(value_type == "fixed_amount"){
//     var value_type_sign = '';
//     var disc_4=parseFloat(disc_2)-parseFloat(discount);
//       }
//     $(".discount-data").attr("data-value",discount);
//     $(".discount-data").attr("data-type",value_type);
//    var final_discount = disc_4.toFixed(2);
//       if(final_discount.split(".")[1] == 99){
//   final_discount = Math.round(final_discount);  
//         final_discount = final_discount.toFixed(2);     
//         final_discount = final_discount.replace('.',',');
// }   else{
//            final_discount = final_discount.replace('.',',');
// }
//     $('<div class="spc_prc"><span class="disc_applied">Mit Code '+ coupen+' nur noch</span><span class="reg_prc">'+currency+final_discount+'</span></div>').insertAfter($(this).find('span.main_price')); 
//    $(this).find('span.main_price').addClass('compr_prc');
//     }
//       }
//       }
//     else {
//       var discount_valid = true;
//       if(discount_valid == true) {
//    var disc_2=parseFloat(disc_1)/100;
//    var value=data['value'];
//     var value_type=data['value_type'];
//     var value_spl=value.split("-");
//     var discount=value_spl[1];
//     if(value_type == 'percentage'){
//     var value_type_sign = '%';
//     var disc_3=((disc_2*discount)/100).toFixed(2);
//     var disc_4=parseFloat(disc_2)-parseFloat(disc_3);
//     }
//     else if(value_type == "fixed_amount"){
//     var value_type_sign = '';
//     var disc_4=parseFloat(disc_2)-parseFloat(discount);
//       }
//     $(".discount-data").attr("data-value",discount);
//     $(".discount-data").attr("data-type",value_type);
//    var final_discount = disc_4.toFixed(2);
//         if(final_discount.split(".")[1] == 99){
//           final_discount = Math.round(final_discount);    
//           final_discount = final_discount.toFixed(2);    
//           final_discount = final_discount.replace('.',',');
// } else{
//            final_discount = final_discount.replace('.',',');
// }
   
//     $('<div class="spc_prc"><span class="reg_prc">'+currency+final_discount+'</span></div>').insertAfter($(this).find('span.main_price')); 
//    $(this).find('span.main_price').addClass('compr_prc');  
//         var coupen = localStorage.getItem("discount_code");
//     var base_url = window.location.origin;  
//     var discount_url = base_url+"/discount/"+coupen;
//     $.get(discount_url,function(){
//     });
//       }
//     } 
//       });
//     }
    
  }
});
        
  },100);
  localStorage.removeItem("page_load");
      
      
      
      
      })
      .catch((e) => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Convert the HTML string to a DOM element
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
     var before_after_slider = tempElement.querySelector('.after-before_slider');
    
    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    document.querySelectorAll('#MainContent script,script[src*="alireviews.min.js"],.theme_main_file').forEach((oldScriptTag) => {
    // document.querySelectorAll('.theme_main_file').forEach((oldScriptTag) => {
    if (!oldScriptTag.classList.contains('custom-element')) {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    }
});

    
    
    // referesh before after slider
    if (before_after_slider != null) {
      after_before_slider();
    }
    // refresh tabs functions
      customAccordian();
  }
  updateCurrentUrl(endpoint,product_title){
        var baseURL = window.location.href.split('/').slice(0, 3).join('/');
        history.pushState(null, null, baseURL + endpoint);

       document.querySelector('head title').innerHTML = product_title;
  }
}

if (!customElements.get('product-swach')) {
  customElements.define('product-swach', ProductSwach);
}